import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Badge } from "react-bootstrap";
import { KSpinner, tooltipate } from "../index";
export var KBUTTON_SIZE;
(function (KBUTTON_SIZE) {
    KBUTTON_SIZE["xs"] = "xs";
    KBUTTON_SIZE["sm"] = "sm";
    KBUTTON_SIZE["nm"] = "nm";
    KBUTTON_SIZE["lg"] = "lg";
})(KBUTTON_SIZE || (KBUTTON_SIZE = {}));
export var KBUTTON_VARIANT;
(function (KBUTTON_VARIANT) {
    KBUTTON_VARIANT["primary"] = "primary";
    KBUTTON_VARIANT["secondary"] = "secondary";
    KBUTTON_VARIANT["success"] = "success";
    KBUTTON_VARIANT["danger"] = "danger";
    KBUTTON_VARIANT["warning"] = "warning";
    KBUTTON_VARIANT["info"] = "info";
    KBUTTON_VARIANT["dark"] = "dark";
    KBUTTON_VARIANT["light"] = "light";
    KBUTTON_VARIANT["link"] = "link";
    KBUTTON_VARIANT["outline-primary"] = "outline-primary";
    KBUTTON_VARIANT["outline-secondary"] = "outline-secondary";
    KBUTTON_VARIANT["outline-success"] = "outline-success";
    KBUTTON_VARIANT["outline-danger"] = "outline-danger";
    KBUTTON_VARIANT["outline-warning"] = "outline-warning";
    KBUTTON_VARIANT["outline-info"] = "outline-info";
    KBUTTON_VARIANT["outline-dark"] = "outline-dark";
    KBUTTON_VARIANT["outline-light"] = "outline-light";
    KBUTTON_VARIANT["stript"] = "stript";
})(KBUTTON_VARIANT || (KBUTTON_VARIANT = {}));
export var KBUTTON_PILL_VARIANT;
(function (KBUTTON_PILL_VARIANT) {
    KBUTTON_PILL_VARIANT["primary"] = "primary";
    KBUTTON_PILL_VARIANT["secondary"] = "secondary";
    KBUTTON_PILL_VARIANT["success"] = "success";
    KBUTTON_PILL_VARIANT["danger"] = "danger";
    KBUTTON_PILL_VARIANT["warning"] = "warning";
    KBUTTON_PILL_VARIANT["info"] = "info";
    KBUTTON_PILL_VARIANT["dark"] = "dark";
    KBUTTON_PILL_VARIANT["light"] = "light";
})(KBUTTON_PILL_VARIANT || (KBUTTON_PILL_VARIANT = {}));
export var KBUTTON_TYPE;
(function (KBUTTON_TYPE) {
    KBUTTON_TYPE["button"] = "button";
    KBUTTON_TYPE["submit"] = "submit";
    KBUTTON_TYPE["reset"] = "reset";
})(KBUTTON_TYPE || (KBUTTON_TYPE = {}));
export const KButton = ({ id, text, disabled, onClick, tooltip, tooltipPlacement = "top", fill = false, type = KBUTTON_TYPE.button, size = KBUTTON_SIZE.nm, variant = KBUTTON_VARIANT.primary, pill, pillVariant = KBUTTON_PILL_VARIANT.primary, style, dark = false, pull, waiting, }) => {
    const button = (_jsx(Button, { id: id, size: size !== KBUTTON_SIZE.nm && size !== KBUTTON_SIZE.xs ? size : undefined, variant: variant !== KBUTTON_VARIANT.stript ? variant : undefined, onClick: onClick, type: type, disabled: disabled || waiting, style: style, className: `${size === KBUTTON_SIZE.xs ? "btn-xs" : size === KBUTTON_SIZE.nm ? "btn-nm" : ""} ${variant === KBUTTON_VARIANT.stript ? "btn-stript" : ""} ${fill ? "fill" : ""} ${dark ? "darkmode" : ""} ${pull ? `float-${pull}` : ""}`, children: waiting ? (_jsx(KSpinner, {})) : (_jsxs(_Fragment, { children: [text, pill ? (_jsx(Badge, { pill: true, bg: pillVariant, children: pill })) : null] })) }));
    return tooltip ? tooltipate(button, tooltip, tooltipPlacement) : button;
};
